/**
 * @flow
 */

import { compose, withProps, withHandlers } from 'recompose';
import PhoneField from '../../components/form/PhoneField';

const props = withProps(() => ({ autoComplete: 'new-password' }));

const handlers = withHandlers({
    /**
     * Handle field onBlur callback to update phone number and trigger user lookup event.
     */
    onBlur: ({ onUserLookup, resetUserLookup, value }) => () => {
        if (value) {
            onUserLookup({
                phone: value.replace(/[^+\d]+/g, ''),
                role: 'SUPPLIER',
            });
        } else {
            resetUserLookup();
        }
    },
});

export default compose(
    props,
    handlers,
)(PhoneField);
